import { useContext, useEffect, useState } from 'react';
import { Title } from '../../components/Title/Title';
import { collectionsContext } from '../../context/collectionsContext';
import styles from './CollectionsContainer.module.css';
import { Collection } from './Collection/Collection';
import { Grid } from '@mui/material';
// type TCollectionsData = {
//   items: {
//     id: number;
//     img: string;
//     name: string;
//     items: TCollectionsDataItem[];
//   }[]
// };
//
// export type TCollectionsDataItem = {
//   id: number;
//   img: string;
//   name: string;
// };

export const CollectionsContainer = () => {
    const { collectionsData } = useContext(collectionsContext);
    const arCollectionsData = Object.values(collectionsData.items);
    const [isLocked, setIsLocked] = useState<any>(false);


    const onCollectionChange = () => {
        console.log('onCollectionChange')
        setIsLocked(true);
        setTimeout(() => {
            setIsLocked(false);
        }, 1000);
        console.log(123)
    }

    // console.log(collectionsData.sectionId)
    return (
        <div>
            <Grid display="grid" gap="20px">
                <div className={styles.baseTitle}>
                    <Title>Коллекция</Title>
                </div>
                <div>
                    <Grid
                        id={'collectionsContainer'}
                        className={styles.collectionsContainer}
                        display="grid"
                        gridTemplateColumns="repeat(3, 1fr)" gap="12px"

                    >
                        {arCollectionsData && arCollectionsData.map((item: any, key) => { //TODO:FIX ANY!!!
                            if(!item?.id) return;
                            return (
                                <Collection
                                    key={item.id}
                                    id={item.id}
                                    img={item.img}
                                    name={item.name}
                                    items={item.items}
                                    currentSectionId={collectionsData.sectionId}
                                    onCollectionChange={() => onCollectionChange()}
                                    isLocked={isLocked}
                                />
                            );
                        })}
                    </Grid>
                </div>
            </Grid>
        </div>
    );
};
